/**
 * Created by tofael on 3/27/17.
 */

import React from 'react';

const styles = {
  display:'block',
  marginLeft:'auto',
  marginRight:'auto'
};

const Logo =()=> <img style={styles} alt="Logo" src="./images/logo.png" height="100" width="206"/>

export default Logo;



// WEBPACK FOOTER //
// ./src/screens/shared/logo.js